import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TicketCommunicationService {

  private tickListUpdate = new Subject<any>();
  constructor() { }

  setTicketListUpdate(data: any) {
    this.tickListUpdate.next(data);
  }

  getTicketListUpdate(): Observable<any> {
    return this.tickListUpdate.asObservable();
  }
}
